import Content, { ContentNS } from "content/content";
import ChecklistItemStatus from "models/checklist/checklist-item/checklist-item-status";
import { FC } from "react";

import { getStatusIcon } from "../utils/get-status-icon";
import StatusIcon from "./styles/StatusIcon.styled";
import StatusValue from "./styles/StatusValue.styled";
import StyledStatusLine from "./styles/StyledStatusLine.styled";

interface StatusProps {
  status: ChecklistItemStatus;
  isInfo: boolean;
}

const StatusLine: FC<StatusProps> = ({ status, isInfo }) => {
  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.checklist });
  const title =
    isInfo && status !== ChecklistItemStatus.Resolved
      ? text(`item-status.info`)
      : text(`item-status.${status}`);

  return (
    <StyledStatusLine>
      <StatusIcon alt="status icon" src={getStatusIcon(status, isInfo)} />
      <StatusValue status={status} isInfo={isInfo}>
        {title}
      </StatusValue>
    </StyledStatusLine>
  );
};

export default StatusLine;
